namespace RioERP.Reports {
    export interface OrderOutstandingReportRow {
        Id?: number;
        OrderId?: number;
        OrderNumber?: string;
        CustomerName?: string;
        CustomerEmail1?: string;
        CustomerMobile1?: string;
        NetAmount?: number;
        SourceType?: Web.Enums.SourceType;
        Status?: Web.Enums.ShippingStatus;
        Recdamount?: number;
        OutstandingAmt?: number;
        OrderDate?: string;
    }

    export namespace OrderOutstandingReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.OrderOutstandingReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderNumber = "OrderNumber",
            CustomerName = "CustomerName",
            CustomerEmail1 = "CustomerEmail1",
            CustomerMobile1 = "CustomerMobile1",
            NetAmount = "NetAmount",
            SourceType = "SourceType",
            Status = "Status",
            Recdamount = "Recdamount",
            OutstandingAmt = "OutstandingAmt",
            OrderDate = "OrderDate"
        }
    }
}
